"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var UsrAdminAccessBrandsList_1 = require("./access/UsrAdminAccessBrandsList");
var UsrAdminAccessGwsGameProvidersList_1 = require("./access/UsrAdminAccessGwsGameProvidersList");
var UsrAdminAccessAffilatesList_1 = require("./access/UsrAdminAccessAffilatesList");
var UsrAdminAccessList = /** @class */ (function (_super) {
    __extends(UsrAdminAccessList, _super);
    function UsrAdminAccessList(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_brands = "brands";
        _this.tab_gws_gameproviders = "gws.gameproviders";
        _this.tab_gws_affilates = "gws.affilates";
        return _this;
    }
    UsrAdminAccessList.prototype.componentWillMount = function () {
        this.props.state.setExtBreadCrumbPath(["Настройка доступа"]);
    };
    UsrAdminAccessList.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_brands },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", null,
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "registered" }),
                        "\u0411\u0440\u0435\u043D\u0434\u044B"), key: this.tab_brands },
                    React.createElement(UsrAdminAccessBrandsList_1.default, { availList: this.props.availBrandsList, dataAccess: this.props.dataAccessBrands, recordKey: this.props.recordKey, dialog: this.props.dialog, onGoBackClick: this.props.onGoBackClick, state: this.props.state })),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", null,
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "dice" }),
                        "\u0413\u0435\u0439\u043C\u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u044B"), key: this.tab_gws_gameproviders },
                    React.createElement(UsrAdminAccessGwsGameProvidersList_1.default, { availList: this.props.availGwsGameProvidersList, dataAccess: this.props.dataAccessGwsGameProvider, recordKey: this.props.recordKey, dialog: this.props.dialog, onGoBackClick: this.props.onGoBackClick, state: this.props.state })),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", null,
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "traffic-light" }),
                        "\u0410\u0444\u0444\u0438\u043B\u0435\u0439\u0442\u044B"), key: this.tab_gws_affilates },
                    React.createElement(UsrAdminAccessAffilatesList_1.default, { availList: this.props.availAffilatesList, dataAccess: this.props.dataAccessAffilates, recordKey: this.props.recordKey, dialog: this.props.dialog, onGoBackClick: this.props.onGoBackClick, state: this.props.state })))));
    };
    return UsrAdminAccessList;
}(React.Component));
exports.default = UsrAdminAccessList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_admins_list/ui/component/UsrAdminAccessList.tsx
// module id = 1894
// module chunks = 0